import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-responsive-video',
  templateUrl: './responsive-video.component.html',
  styleUrls: ['./responsive-video.component.scss']
})
export class ResponsiveVideoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
